export default __webpack_public_path__ + "static/colony-9f4eb7c016f97a51ace446f44501daf9.png";